import React, { useState, useEffect } from "react";
import clsx from "clsx";
import {
    Grid,
    Typography,
    Button,
    TextField,
    MenuItem,
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    TablePagination,
    Dialog,
    DialogActions,
    DialogContent,
    DialogContentText,
    DialogTitle,
    Checkbox,
    InputAdornment,
    IconButton,
    FormControl,
    InputLabel,
    Input,
    FormControlLabel
} from "@mui/material";
import BackButton from "../../components/BackButton/BackButton";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";

import SearchIcon from "@mui/icons-material/Search";
// import { Visibility, VisibilityOff } from "@mui/icons-material";
// import {
//     MuiPickersUtilsProvider,
//     DatePicker
// } from "@mui/material/pickers";
// import Tooltip from "@mui/material/Tooltip";
import { Tooltip } from "antd";
import { NavLink } from "react-router-dom";
import Layout from "../../components/Wrappers/Layout";
import { Card, Alert } from "reactstrap";
// import { AiOutlineSearch, AiOutlineUser } from "react-icons/ai";
import { useSelector, useDispatch } from "react-redux";
import { makeStyles } from "@mui/styles";
import CustomButton from "../../../src/components/CustomButton/CustomButton";
import { useHistory, useNavigate } from "react-router-dom";
import success from "../../assets/img/success.png";
import failed from "../../assets/img/failed.png";
import LoadingSpinner from "../../components/LoadingSpinner/LoadingSpinner";
import SOLogout from "../../components/Logout/SOLogout";
import FileBase64 from "../../components/Upload/UploadFile";
import regenerateToken from "../../components/RegenerateToken/regenerateToken";
import Util from "../../validation/index";
import { dealerAddUpdateDivisonList } from '../../redux/actions/dealerAddUpdateDivisionListAction';
import { dealerAddUpdateDistrictList } from "../../redux/actions/dealerAddUpdateDistrictListAction";
import { dealerAddUpdateThanaList } from '../../redux/actions/dealerAddUpdateThanaListAction';
import { dealerAddUpdateUnionList } from '../../redux/actions/dealerAddUpdateUnionListAction';
import { dealerDsrMappingList } from "../../redux/actions/dealerDsrMappingListAction";
import { dealerDeleteDsr } from "../../redux/actions/dealerDeleteDsrAction";
import { dealerDsrList } from "../../redux/actions/dealerDsrListAction";
import { dealerAddEditDsr } from "../../redux/actions/dealerAddEditDsrAction";
import { getRoleDropListsForDealer } from "../../redux/actions/getRoleDropListForDealerAction"
const useStyles = makeStyles((theme) => ({
    table: {
        minWidth: 650
    },
    margin: {
        margin: theme.spacing(1)
    },
    root: {
        display: "flex",
        flexWrap: "wrap"
    },
    textField: {
        width: "25ch"
    }
}));

const DealerAgentMaster = () => {

    // const [agentNumber, setAgentNumber] = useState("");
    // const [agentName, setAgentName] = useState("");
    // const [agentId, setAgentId] = useState("");
    // const [getRole, setGetRole] = useState("");
    const [editDivision, setEditDivision] = useState("");
    const [editDistrict, setEditDistrict] = useState("");
    const [editThana, setEditThana] = useState("");
    const [editUnion, setEditUnion] = useState("");
    const [pageToggle, setPageToggle] = useState(false);

    const [setAddUpdateDivisionListStatus, setSetAddUpdateDivisionListStatus] = useState(false);
    const [setAddUpdateDivisionListArray, setSetAddUpdateDivisionListArray] = useState([]);

    const [setAddUpdateDistrictListStatus, setSetAddUpdateDistrictListStatus] = useState(false);
    const [setAddUpdateDistrictListArray, setSetAddUpdateDistrictListArray] = useState([]);


    const [setAddUpdateThanaListStatus, setSetAddUpdateThanaListStatus] = useState(false);
    const [setAddUpdateThanaListArray, setSetAddUpdateThanaListArray] = useState([]);

    const [setAddUpdateUnionListStatus, setSetAddUpdateUnionListStatus] = useState(false);
    const [setAddUpdateUnionListArray, setSetAddUpdateUnionListArray] = useState([]);
    const navigate = useHistory();

    const classes = useStyles();
    const dispatch = useDispatch();
    const [deleteOpen, setDeleteOpen] = useState(false)
    const [notificationOpen, setNotificationOpen] = React.useState(false);
    const [deleteNotification, setDeleteNotification] = useState(false)

    const [addEditDsrNotification, setAddEditDsrNotification] = useState(false)

    const [addDsrNotification, setAddDsrNotification] = useState(false)


    const [editOpen, setEditOpen] = useState(false)
    const [addDsrOpen, setAddDsrOpen] = useState(false)

    const [getAgentMasterListStatus, setGetAgentMasterListStatus] = useState(false);
    const [getAgentMasterListArray, setGetAgentMasterListArray] = useState("");

    const [deleteDsrMasterStatus, setDeleteDsrMasterStatus] = useState(false)
    const [deleteDsrMasterArray, setDeleteDsrMasterArray] = useState("")



    const [setDsrListStatus, setSetDsrListStatus] = useState(false);
    const [setDsrListArray, setSetDsrListArray] = useState([]);

    const [GetRoleDropListStatus, setGetRoleDropListStatus] = useState(false);
    const [GetRoleDropListArray, setGetRoleDropListArray] = useState([]);



    const [addEditDsrStatus, setAddEditDsrStatus] =
        useState(false);
    const [addEditDsrStatusResArray, setAddEditDsrStatusResArray] =
        useState("");

    const [addDsrStatus, setAddDsrStatus] =
        useState(false);
    const [addDsrStatusResArray, setAddDsrStatusResArray] =
        useState("");


    const [idNumber, setIdNumber] = useState("")
    // const [getIdNumber, setGetIdNumber] = useState("")


    //Edit Dsr
    const [agentComboName, setAgentComboName] = useState("")
    const [Role, setRole] = useState("");
    const [mobileNo, setMobileNo] = useState("")
    const [getDivision, setGetDivision] = useState("");
    const [getDistrict, setGetDistrict] = useState("");
    const [getThana, setGetThana] = useState("");
    const [getUnion, setGetUnion] = useState("");
    const [getdsrId, setGetdsrId] = useState("");
    const [getEmailOtp, setGetEmailOtp] = useState("");
    const [custId, setCustId] = useState("");
    const [idNum, setIdNum] = useState("");
    const [getAgentList, setGetAgentList] = useState("");

    const [emailOtp, setEmailOtp] = useState("");


    const partnerloginUser = useSelector(({ login }) => login);
    // var authToken = partnerloginUser.data.AuthToken;
    const regenerateTokenRes = useSelector(
        ({ regenerateToken }) => regenerateToken
    );
    var authToken = regenerateTokenRes.data.AuthToken;

    const getDealerDsrMappingListRes = useSelector(
        ({ dealerDsrMappingLists }) => dealerDsrMappingLists
    );
    const deleteDealerDsrRes = useSelector(
        ({ dealerDeleteDsrList }) => dealerDeleteDsrList
    )

    const setDsrList = useSelector(({ dealerDsrList }) => dealerDsrList);

    const getAddEditDsrListRes = useSelector(({ dealerAddEditDsrLists }) => dealerAddEditDsrLists)

    const getAddDsrListRes = useSelector(({ dealerAddEditDsrLists }) => dealerAddEditDsrLists)


    const getRoleDropListDealerRes = useSelector(
        ({ dealerGetRoleDropLists }) => dealerGetRoleDropLists
    )
    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [isLoading, setIsLoading] = useState(true);

    const [user, setUser] = useState({
        dsrId: "",
        dsrName: "",
        dsrNumber: "",
        thana: "",
        union: "",
        division: "",
        district: "",
        agentList: "",
        getRole: "",


    });
    const {
        dsrId,
        dsrName,
        dsrNumber,
        thana,
        union,
        division,
        district,
        agentList,
        getRole,
    } = user
    // const handleChange = ({ target: { name, value } }) => {
    //     // if (name === "AgentNumber") {
    //     //     Util.verifyMobile(value)
    //     //         ? setAgentNumber(value)
    //     //         : setAgentNumber(agentNumber);
    //     // }
    //     // if (name === "AgentName") {
    //     //     Util.verifyAlphabet(value)
    //     //         ? setAgentName(value)
    //     //         : setAgentName(agentName);
    //     // }
    //     // if (name === "AgentId") {
    //     //     Util.verifyAlphabet(value) ? setAgentId(value) : setAgentId(agentId);
    //     // }
    //     // if (name === "Role") {
    //     //     setGetRole(value == "Select Role" ? "" : value);
    //     // }

    //     if (name === "EditDivision") {
    //         // setCurrency(value);
    //         // setEditCurrency(value);
    //         setEditDivision(value == "Select Division" ? "" : value);
    //     }
    //     if (name === "EditDistrict") {
    //         // setCurrency(value);
    //         // setEditCurrency(value);
    //         setEditDistrict(value == "Select District" ? "" : value);
    //     }
    //     if (name === "EditThana") {
    //         setEditThana(value == "Select Thana" ? "" : value);
    //     }
    //     if (name === "EditUnion") {
    //         setEditUnion(value == "Select Union" ? "" : value);
    //     }
    // };

    const onInputChangeMod = ({ target: { name, value } }, type) => {

        const obj = {
            ...user,

        };
        if (type == "number") {
            obj[name] = Util.verifyMobile(value) ? value : obj[name];
        } else if (type == "alphabet") {
            obj[name] = Util.verifyAlphabet(value) ? value : obj[name];
        } else if (type == "both") {
            obj[name] = Util.alphaNumeric(value) ? value : obj[name];
        } else {
            // obj[name] = value.trim()
            // obj[name] = Util.noWhiteSpace(value) ? value : obj[name];
            obj[name] = value

        }
        setUser(obj);
    }
    const setDivisionList = useSelector(
        ({ dealerAddUpdateDivisionLists }) => dealerAddUpdateDivisionLists
    )
    const setDistrictList = useSelector(
        ({ dealerAddUpdateDistrictLists }) => dealerAddUpdateDistrictLists
    )

    const setThanaList = useSelector(
        ({ dealerAddUpdateThanaLists }) => dealerAddUpdateThanaLists
    )

    const setUnionList = useSelector(
        ({ dealerAddUpdateUnionLists }) => dealerAddUpdateUnionLists
    )

    const handleClose = () => {
        setDeleteOpen(false)
        setEditOpen(false)
        setAddDsrOpen(false)
    }
    const handleNoticationClose = () => {
        setNotificationOpen(false);
        setDeleteNotification(false);
        setAddEditDsrNotification(false);
        setAddDsrNotification(false);

        setEditOpen(false)
        setDeleteOpen(false)
        setAddDsrOpen(false)



    };

    const handleChange = ({ target: { name, value } }) => {
        if (name === "AgentComboName") {
            // setAgentComboName(value == "Select Dsr" ? "" : value);
            setAgentComboName(value)
        }
        // if (name === "Role") {
        //     setRole(value);
        // }
        if (name === "Role") {

            setRole(value == "Select Role" ? "" : value);
        }

        if (name === "MobileNumber") {
            setMobileNo(value);
        }

        if (name === "Division") {
            setGetDivision(value)
        }

        if (name === "District") {
            setGetDistrict(value)
        }

        if (name === "Thana") {
            setGetThana(value)
        }

        if (name === "Union") {
            setGetUnion(value)
        }
        if (name === "getEmailOtp") {
            setGetEmailOtp(value);
            // setLevel(value);
        }
        if (name === "agentList") {
            setGetAgentList(value == "All" ? "" : value);

        }
        if (name === "EditDivision") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDivision(value == "Select Division" ? "" : value);
        }
        if (name === "EditDistrict") {
            // setCurrency(value);
            // setEditCurrency(value);
            setEditDistrict(value == "Select District" ? "" : value);
        }
        if (name === "EditThana") {

            setEditThana(value == "Select Thana" ? "" : value);
        }
        if (name === "EditUnion") {

            setEditUnion(value == "Select Union" ? "" : value);
        }




    };
    const setGetRoleDropListDealerReq = () => {
        setGetRoleDropListStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || ""


            }
        };
        dispatch(getRoleDropListsForDealer(req, authToken));
    };

    const GetRoleDropListDealerFunc = () => {
        if (GetRoleDropListStatus) {
            if (getRoleDropListDealerRes.data.status == "success") {
                setGetRoleDropListArray([].concat(getRoleDropListDealerRes.data.currencyList));
            }
            if (getRoleDropListDealerRes.data.status == "failed") {
                setGetRoleDropListArray(getRoleDropListDealerRes.data);
                if (
                    getRoleDropListDealerRes.data.description == "session out"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
                if (
                    getRoleDropListDealerRes.data.description == "Authorization failed"
                ) {
                    regenerateToken(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };

    useEffect(() => {
        GetRoleDropListDealerFunc();
    }, [getRoleDropListDealerRes.data.status]);



    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            setGetRoleDropListDealerReq();
        }
    }, [regenerateTokenRes.data.status]);

    const dealerDsrMappingListReq = () => {
        setGetAgentMasterListStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                dsrId: dsrId,
                dsrName: dsrName,
                dsrNumber: dsrNumber,
                thana: editThana,
                union: editUnion,
                division: editDivision === "Select Divison" ? "" : editDivision,
                district: editDistrict,
                agentTypeList: getAgentList,
                role: Role
            }
        }
        dispatch(dealerDsrMappingList(req, authToken))
    }





    const dealerDsrMappingListFunc = () => {
        if (getAgentMasterListStatus) {
            if (getDealerDsrMappingListRes.data.status == "success") {
                setGetAgentMasterListArray([].concat(getDealerDsrMappingListRes.data.dsrList))
                // dealerAddDsrFunc()
                setIsLoading(false)
            }
            if (getDealerDsrMappingListRes.data.status == "failed") {
                setGetAgentMasterListArray(getDealerDsrMappingListRes.data)
                setIsLoading(false)
            }
            if (getDealerDsrMappingListRes.data.status == "NOT FOUND") {
                setGetAgentMasterListArray(getDealerDsrMappingListRes.data)
                setIsLoading(false)
            }
        }
    }
    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            dealerDsrMappingListReq();
        }
    }, [regenerateTokenRes.data.status]);


    useEffect(() => {
        dealerDsrMappingListFunc()
    }, [getDealerDsrMappingListRes.data.status])


    useEffect(() => {
        if (getDealerDsrMappingListRes.data.status == "success") {
            setPage(0);
        }
    }, [getDealerDsrMappingListRes.data.status]);



    const deleteUserFunc = (idNumber, emailOtp) => {
        // if (deleteDealerDsrRes.data.status == "success") {

        // }
        setEmailOtp(emailOtp)
        setIdNumber(idNumber)
        setDeleteOpen(true);
    };

    const deleteDealerDsrReq = () => {
        setDeleteDsrMasterStatus(true)
        let req = {
            actionCustomerMasterRequestVO: {

                dealerId: regenerateTokenRes.data.partnerId,
                id: idNumber
            }
        }
        dispatch(dealerDeleteDsr(req, authToken));
        setDeleteOpen(false)


    }


    const dealerDeleteDsrFunc = () => {
        if (deleteDsrMasterStatus) {
            if (deleteDealerDsrRes.data.status == "success") {
                setDeleteDsrMasterArray(deleteDealerDsrRes.data)
                setDeleteNotification(true)
                dealerDsrMappingListReq()

            }
            if (deleteDealerDsrRes.data.status == "failed") {
                setDeleteDsrMasterArray(deleteDealerDsrRes.data)
                setDeleteNotification(true)
            }
        }
    }

    useEffect(() => {
        dealerDeleteDsrFunc()
    }, [deleteDealerDsrRes.data.status])


    const EditDsrList = (
        agentComboName,
        Role,
        mobileNo,
        getDivision,
        getDistrict,
        getUnion,
        getThana,
        getEmailOtp,
        custId,
        idNum,


    ) => {

        setAgentComboName(agentComboName);
        setRole(Role);
        setMobileNo(mobileNo);
        setGetDivision(getDivision);
        setGetDistrict(getDistrict);
        setGetUnion(getUnion);
        setGetThana(getThana);
        setGetEmailOtp(getEmailOtp);
        setCustId(custId);
        setIdNum(idNum)


        setEditOpen(true)



    }
    const AddDsrList = (
        agentComboName,
        Role,
        mobileNo,
        getDivision,
        getDistrict,
        getUnion,
        getThana,
        getEmailOtp,
        custId,

        // idNum,


    ) => {

        setAgentComboName(agentComboName);
        setRole(Role);
        setMobileNo(mobileNo);
        setGetDivision(getDivision);
        setGetDistrict(getDistrict);
        setGetUnion(getUnion);
        setGetThana(getThana);
        setGetEmailOtp(getEmailOtp);
        setCustId(custId);
        // setIdNum(idNum)


        setAddDsrOpen(true)



    }
    const setDsrListReq = () => {
        setSetDsrListStatus(true);
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || ""


            }
        };
        dispatch(dealerDsrList(req, authToken));
    };
    const DsrListFunc = () => {
        if (setDsrListStatus) {
            if (setDsrList.data.status == "success") {
                setSetDsrListArray([].concat(setDsrList.data.actionList));
            }
            if (setDsrList.data.status == "failed") {
                setSetDsrListArray(setDsrList.data);
                if (
                    setDsrList.data.description == "session out" ||
                    setDsrList.data.description == "Authorization failed"
                ) {
                    SOLogout(dispatch, authToken, regenerateTokenRes.data.partnerId);
                }
            }
        }
    };
    useEffect(() => {
        DsrListFunc();
    }, [setDsrList.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {
            setDsrListReq();
        }
    }, [regenerateTokenRes.data.status]);



    const getAddEditDsrReq = () => {
        setAddEditDsrStatus(true)
        const request = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                id: idNum,
                customerId: custId,
                dsrId: getEmailOtp.split("-")[0]
            }
        }
        dispatch(dealerAddEditDsr(request, authToken))
        setEditOpen(false)

    }

    const dealerAddEditDsrFunc = () => {
        if (addEditDsrStatus) {
            if (getAddEditDsrListRes.data.status == "success") {
                setAddEditDsrStatusResArray(getAddEditDsrListRes.data)
                setAddEditDsrNotification(true)
                dealerDsrMappingListReq()

            }
            if (getAddEditDsrListRes.data.status == "failed") {
                setAddEditDsrStatusResArray(getAddEditDsrListRes.data)
                setAddEditDsrNotification(true)
            }
        }
    }

    useEffect(() => {
        dealerAddEditDsrFunc()
    }, [getAddEditDsrListRes.data.status])


    const getAddDsrReq = () => {
        setAddDsrStatus(true)
        const Request = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId,
                id: "",
                customerId: custId,
                dsrId: getEmailOtp.split("-")[0]
            }
        }
        dispatch(dealerAddEditDsr(Request, authToken))
        setAddDsrOpen(false)

    }

    const dealerAddDsrFunc = () => {
        if (addDsrStatus) {
            if (getAddDsrListRes.data.status == "success") {
                setAddDsrStatusResArray(getAddDsrListRes.data)
                setAddDsrNotification(true)
                dealerDsrMappingListReq()

            }
            if (getAddDsrListRes.data.status == "failed") {
                setAddDsrStatusResArray(getAddDsrListRes.data)
                setAddDsrNotification(true)
            }
        }
    }

    useEffect(() => {
        dealerAddDsrFunc()
    }, [getAddDsrListRes.data.status])

    const setAddUpdateDivisionListReq = () => {
        setSetAddUpdateDivisionListStatus(true)
        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",


            }
        }
        dispatch(dealerAddUpdateDivisonList(req, authToken))
    }
    const AddUpdateDivisionListFunc = () => {
        if (setAddUpdateDivisionListStatus) {
            if (setDivisionList.data.status == "success") {
                setSetAddUpdateDivisionListArray(setDivisionList.data.list);
            }
            if (setDivisionList.data.status == "failed") {
                setSetAddUpdateDivisionListArray(setDivisionList.data);
            }
        }
    };
    useEffect(() => {
        AddUpdateDivisionListFunc();
    }, [setDivisionList.data.status]);

    useEffect(() => {
        if (regenerateTokenRes.data.status == "success") {

            setAddUpdateDivisionListReq()

        }
    }, [regenerateTokenRes.data.status])
    // useEffect(() => {
    //     setAddUpdateDivisionListReq()
    // }, [])

    const setAddUpdateDistrictListReq = () => {
        setSetAddUpdateDistrictListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDivision

            }
        }
        dispatch(dealerAddUpdateDistrictList(req, authToken))
    }
    const AddUpdateDistrictListFunc = () => {
        if (setAddUpdateDistrictListStatus) {
            if (setDistrictList.data.status == "success") {
                setSetAddUpdateDistrictListArray(setDistrictList.data.list);
            }
            if (setDistrictList.data.status == "failed") {
                setSetAddUpdateDistrictListArray(setDistrictList.data);
            }
        }
    };

    useEffect(() => {
        if (editDivision) {
            setAddUpdateDistrictListReq()
        }
    }, [editDivision])

    // useEffect(() => {
    //     setAddUpdateDistrictListReq()
    // }, [editDivision])


    useEffect(() => {
        AddUpdateDistrictListFunc()
    }, [setDistrictList.data.status])

    const setAddUpdateThanaListReq = () => {
        setSetAddUpdateThanaListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict

            }
        }
        dispatch(dealerAddUpdateThanaList(req, authToken))
    }
    const AddUpdateThanaListFunc = () => {
        if (setAddUpdateThanaListStatus) {
            if (setThanaList.data.status == "success") {
                setSetAddUpdateThanaListArray(setThanaList.data.list);
            }
            if (setThanaList.data.status == "failed") {
                setSetAddUpdateThanaListArray(setThanaList.data);
            }
        }
    };
    useEffect(() => {
        if (editDistrict) {
            setAddUpdateThanaListReq()
        }
    }, [editDistrict])

    // useEffect(() => {
    //     setAddUpdateThanaListReq()
    // }, [editDistrict])


    useEffect(() => {
        AddUpdateThanaListFunc();
    }, [setThanaList.data.status]);

    const setAddUpdateUnionListReq = () => {
        setSetAddUpdateUnionListStatus(true)

        const req = {
            actionCustomerMasterRequestVO: {
                dealerId: regenerateTokenRes.data.partnerId || "",
                district: editDistrict,
                thana: editThana

            }
        }
        dispatch(dealerAddUpdateUnionList(req, authToken))
    }

    const AddUpdateUnionListFunc = () => {
        if (setAddUpdateUnionListStatus) {
            if (setUnionList.data.status == "success") {
                setSetAddUpdateUnionListArray(setUnionList.data.list);
            }
            if (setUnionList.data.status == "failed") {
                setSetAddUpdateUnionListArray(setUnionList.data);
            }
        }
    };

    // useEffect(() => {
    //     setAddUpdateUnionListReq()
    // }, [editDivision, editThana])

    useEffect(() => {
        AddUpdateUnionListFunc();
    }, [setUnionList.data.status]);

    useEffect(() => {
        if (editDistrict && editThana) {
            setAddUpdateUnionListReq()
        }
    }, [editDistrict, editThana])
    useEffect(() => {

        // setEditDivision('');
        setEditDistrict('');
        setEditThana('');
        setEditUnion('')

    }, [editDivision])

    const sendCustomerId = (customerId) => {
        // setPageToggle(true);
        navigate.push({
            pathname: `/index/DealerViewUserMaster`,
            state: { param1: `${customerId}` }
        });
    };

    return (
        <>
            <Layout>
                <BackButton />
                <Card>
                    <Grid container style={{ padding: "25px", justifyContent: "right" }}>
                        {/* <Grid item md={7} sm={12} lg={5}></Grid> */}
                        <Grid item md={3} sm={12} xs={12} lg={2}>
                            <NavLink to="/index/DealerMultipleDsrMapping">
                                <CustomButton
                                    style={{
                                        padding: "8px",
                                        margin: "0 8px"
                                    }}
                                >
                                    Multiple mapping
                                </CustomButton>
                            </NavLink>
                        </Grid>
                        <Grid item md={3} sm={12} xs={12} lg={2}>
                            <NavLink to="/index/DealerAgentUpload">
                                <CustomButton
                                    style={{
                                        padding: "8px",
                                        margin: "0 8px"
                                    }}
                                >
                                    Agent upload
                                </CustomButton>
                            </NavLink>
                        </Grid>
                    </Grid>

                    <Grid
                        container
                        spacing={2}
                        style={{ padding: "25px", marginTop: "2rem" }}
                    >
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Number"
                                fullWidth={true}
                                name="dsrNumber"
                                value={dsrNumber}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "number")}

                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Name"
                                fullWidth={true}
                                name="dsrName"
                                value={dsrName}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "alphabet")}

                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                size="small"
                                color="primary"
                                type="text"
                                label="Agent Id"
                                fullWidth={true}
                                name="dsrId"
                                value={dsrId}
                                // onChange={onInputChange}
                                onChange={(e) => onInputChangeMod(e, "number")}
                            ></TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Role"
                                fullWidth={true}
                                name="Role"
                                // value={getRole || ""}
                                defaultValue={"Select Role" || Role}
                                onChange={handleChange}
                            >
                                <MenuItem value="Select Role" selected="Select Role">
                                    Select Role
                                </MenuItem>
                                {getRoleDropListDealerRes.success && [].concat(getRoleDropListDealerRes.data.currencyList)
                                    .map((x) => <MenuItem value={x}>{x}</MenuItem>)}
                                {/* <MenuItem value="MERCHANT">MERCHANT</MenuItem> */}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Division"
                                fullWidth={true}
                                name="EditDivision"
                                value={editDivision || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select Divison" selected="Select Divison">
                                    Select Division
                                </MenuItem>
                                {/* {setDivisionList.success} */}
                                {setDivisionList.success &&
                                    setDivisionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>

                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="District"
                                fullWidth={true}
                                name="EditDistrict"
                                value={editDistrict || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select District" selected="Select District">
                                    Select District
                                </MenuItem>
                                {setDistrictList.success &&
                                    setDistrictList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">
                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Thana/Upazilla"
                                fullWidth={true}
                                name="EditThana"
                                value={editThana || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select Thana/Upazilla" selected="Select Thana/Upazilla">
                                    Select Thana/Upazilla
                                </MenuItem>

                                {setThanaList.success &&
                                    setThanaList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4} className="mt-2">

                            <TextField
                                select
                                type="text"
                                size="small"
                                color="primary"
                                autoFocus={true}
                                label="Union/Ward"
                                fullWidth={true}
                                name="EditUnion"
                                value={editUnion || ""}
                                // onChange={(e) => onInputChangeMod(e)}
                                onChange={handleChange}

                            >
                                <MenuItem value="Select Union/Ward" selected="Select Union/Ward">
                                    Select Union/Ward
                                </MenuItem>
                                {setUnionList.success &&
                                    setUnionList.data.list.map((x) => (
                                        <MenuItem value={x.name}>{x.name}</MenuItem>
                                    ))}
                            </TextField>
                        </Grid>
                        <Grid item xs={12} sm={6} md={4} lg={4}>
                            <TextField
                                select
                                margin="dense"
                                autoFocus={true}
                                label="Select Agent List"
                                fullWidth={true}
                                name="agentList"

                                defaultValue={"All" || getAgentList}
                                onChange={handleChange}
                            >
                                <MenuItem value="All" selected="All">
                                    All
                                </MenuItem>
                                <MenuItem value="wDSR">WITH-DSR</MenuItem>
                                <MenuItem value="woDSR">WITHOUT-DSR</MenuItem>

                            </TextField>
                        </Grid>

                        <Grid item xs={12} sm={6} md={4} lg={3}>

                            <CustomButton
                                style={{
                                    padding: "8px",
                                    margin: "8px 8px"
                                }}
                                variant="contained"
                                onClick={dealerDsrMappingListReq}
                            >
                                Search
                                <SearchIcon style={{ marginLeft: "4px", fontSize: "21px" }} />
                            </CustomButton>
                        </Grid>
                    </Grid>
                </Card>
                {isLoading ? (
                    <LoadingSpinner />
                ) : getAgentMasterListArray.length == undefined ||
                    !getAgentMasterListStatus ? (
                    <Card>
                        <Grid
                            container
                            style={{
                                padding: "10px"
                            }}
                        >
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Alert
                                    className="my-3 themeBackground"
                                    variant="secondary"
                                    style={{ color: "white" }}
                                >
                                    No Records Found!
                                </Alert>
                            </Grid>
                        </Grid>
                    </Card>
                ) : (
                    <div>
                        <Card>
                            <Grid
                                container
                                style={{
                                    padding: "10px"
                                }}
                            >
                            </Grid>
                            <Grid xs={12} sm={12} md={12} lg={12}>
                                <Typography
                                    variant="body1"
                                    style={{ fontWeight: "700" }}
                                    className="themeText"
                                >
                                    Report Table
                                </Typography>
                            </Grid>
                            <TableContainer component={Paper} className="text-nowrap my-3">
                                <Table className={classes.table}
                                    aria-label="a dense table"
                                // size="small"

                                >
                                    <TableHead>
                                        <TableRow
                                            style={{ background: "#00b9f5" }}
                                            className="themeBackground"
                                        >
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Agent Id{" "}
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Agent/Combo Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                {" "}
                                                Mobile No
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Division{" "}
                                            </TableCell>

                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                District
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Thana
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Union
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Role
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Dsr Name
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Dsr Mob no
                                            </TableCell>
                                            <TableCell
                                                align="center"
                                                style={{ fontWeight: "bold", color: "white" }}
                                            >
                                                Action
                                            </TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody className="">
                                        {getAgentMasterListArray &&
                                            []
                                                .concat(getAgentMasterListArray)
                                                .slice
                                                (
                                                    page * rowsPerPage,
                                                    page * rowsPerPage + rowsPerPage
                                                )
                                                .map((row, index) => (
                                                    <TableRow key={index}>
                                                        <TableCell
                                                            align="center"
                                                            style={{
                                                                // marginTop: "1rem",
                                                                // marginLeft: "rem",
                                                                // color: "#00b9f5",
                                                                cursor: "pointer",
                                                                fontWeight: "600"
                                                            }}
                                                            className="themeColor"
                                                        >
                                                            <span
                                                                onClick={() => sendCustomerId(row.customerId)}
                                                            >
                                                                {row.customerId}
                                                            </span>
                                                        </TableCell>
                                                        {/* <TableCell align="center">
                                                            {row.customerId}
                                                        </TableCell> */}
                                                        <TableCell align="center">
                                                            {row.customerName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.mobNumber}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.division}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.state}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.city}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.union}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.userRole}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.userName}
                                                        </TableCell>
                                                        <TableCell align="center">
                                                            {row.customerEmail}
                                                        </TableCell>
                                                        {/* <TableCell align="center">
                                                            {row.union}
                                                        </TableCell> */}
                                                        <TableCell
                                                            align="center"
                                                        >
                                                            {/* <Tooltip title="Add DSR"> */}
                                                            {row.emailOtp == "" ? (
                                                                <>
                                                                    <Tooltip title="Add DSR">

                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px",
                                                                                // margin: "0 8px"
                                                                            }}
                                                                            onClick={() =>
                                                                                AddDsrList(
                                                                                    row.customerName,
                                                                                    row.userRole,
                                                                                    row.mobNumber,
                                                                                    row.division,
                                                                                    row.state,
                                                                                    row.city,
                                                                                    row.union,
                                                                                    row.emailOtp,
                                                                                    row.customerId,
                                                                                    // row.idNumber
                                                                                )
                                                                            }
                                                                        >
                                                                            Add DSR
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                </>
                                                            ) : (

                                                                // <CustomButton
                                                                //     style={{
                                                                //         padding: "8px",
                                                                //         margin: "0 8px"
                                                                //     }}
                                                                //     onClick={() =>
                                                                //         AddDsrList(

                                                                //             row.customerName,
                                                                //             row.userRole,
                                                                //             row.mobNumber,
                                                                //             row.division,
                                                                //             row.state,
                                                                //             row.city,
                                                                //             row.union,
                                                                //             row.emailOtp,

                                                                //             row.customerId,
                                                                //             // row.idNumber
                                                                //         )
                                                                //     }
                                                                // >
                                                                //     Add DSR
                                                                // </CustomButton>
                                                                <>
                                                                    <Tooltip title="Delete">
                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px"
                                                                            }}
                                                                            onClick={() =>
                                                                                deleteUserFunc(row.idNumber, row.emailOtp)
                                                                            }
                                                                        >
                                                                            {
                                                                                <DeleteIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            }
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                    <Tooltip title="Edit">

                                                                        <CustomButton
                                                                            style={{
                                                                                padding: "8px"
                                                                            }}
                                                                            onClick={() =>
                                                                                EditDsrList(
                                                                                    row.customerName,
                                                                                    row.userRole,
                                                                                    row.mobNumber,
                                                                                    row.division,
                                                                                    row.state,
                                                                                    row.city,
                                                                                    row.union,
                                                                                    row.emailOtp,
                                                                                    row.customerId,
                                                                                    row.idNumber

                                                                                )
                                                                            }
                                                                        >
                                                                            {
                                                                                <EditIcon
                                                                                    style={{
                                                                                        color: "#fff",
                                                                                        fontSize: "20px"
                                                                                    }}
                                                                                />
                                                                            }
                                                                        </CustomButton>
                                                                    </Tooltip>

                                                                </>
                                                            )
                                                            }
                                                            {/* </Tooltp> */}
                                                            {/* <Tooltip title="Edit">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        EditDsrList(

                                                                            row.customerName,
                                                                            row.userRole,
                                                                            row.mobNumber,
                                                                            row.division,
                                                                            row.state,
                                                                            row.city,
                                                                            row.union,
                                                                            row.emailOtp,

                                                                            row.customerId,
                                                                            row.idNumber

                                                                        )
                                                                    }
                                                                >

                                                                    <EditIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />

                                                                </CustomButton>
                                                            </Tooltip>
                                                            <Tooltip title="Delete">
                                                                <CustomButton
                                                                    style={{
                                                                        padding: "8px"
                                                                    }}
                                                                    onClick={() =>
                                                                        deleteUserFunc(row.idNumber)
                                                                    }
                                                                >

                                                                    <DeleteIcon
                                                                        style={{
                                                                            color: "#fff",
                                                                            fontSize: "20px"
                                                                        }}
                                                                    />

                                                                </CustomButton>
                                                            </Tooltip> */}

                                                        </TableCell>

                                                    </TableRow>
                                                )
                                                )
                                        }
                                    </TableBody>
                                </Table>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25]}
                                    component="div"
                                    count={[].concat(getAgentMasterListArray).length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onChangePage={handleChangePage}
                                    onChangeRowsPerPage={handleChangeRowsPerPage}
                                />
                            </TableContainer>
                        </Card>
                    </div>
                )
                }
            </Layout>


            <div>
                <Dialog open={deleteOpen} onClose={handleClose}>
                    <DialogTitle style={{ width: "400px" }}>Are you sure?</DialogTitle>
                    <DialogActions className="p-3">
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                // color: "#000"
                                padding: "8px"

                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                padding: "8px",
                                width: "60px"

                            }}
                            onClick={deleteDealerDsrReq}
                        // onClick={() =>
                        //     deleteDealerDsrReq()
                        // }
                        >
                            Yes
                        </CustomButton>
                    </DialogActions>
                </Dialog>
            </div>

            <div>
                <Dialog open={editOpen} onClose={handleClose}>
                    <DialogTitle>Update Dsr Mapping</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Agent/Combo Name"
                            fullWidth={true}
                            name="AgentComboName"
                            value={agentComboName || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="Role"
                            value={Role || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Mobile No"
                            fullWidth={true}
                            name="MobileNumber"
                            value={mobileNo || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Divison"
                            fullWidth={true}
                            name="Division"
                            value={getDivision || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="District"
                            fullWidth={true}
                            name="District"
                            value={getDistrict || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Thana"
                            fullWidth={true}
                            name="Thana"
                            value={getThana || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Union"
                            fullWidth={true}
                            name="Union"
                            value={getUnion || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getEmailOtp"
                                value={getEmailOtp || ""}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >
                                {/* <MenuItem value="Select Dsr" selected="Select Level">
                                    Select Dsr
                                </MenuItem> */}
                                {/* {setDsrList.success} */}
                                {/* <MenuItem value="BASIC">BASIC</MenuItem> */}
                                {setDsrList.success && [].concat(setDsrList.data.actionList)
                                    .map((x) => <MenuItem value={x.split("-")[0]}
                                    // selected={() => {
                                    //     getEmailOtp == x.substring(0, 6) ? "" : "undefined"
                                    // }}
                                    // selected={dsrDropdown(x)}
                                    // selected={'190032-Soham-7875612343'}
                                    >{x}</MenuItem>)}

                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getAddEditDsrReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>

            <div>
                <Dialog open={addDsrOpen} onClose={handleClose}>
                    <DialogTitle>Update Dsr Mapping</DialogTitle>
                    <DialogContent>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Agent/Combo Name"
                            fullWidth={true}
                            name="AgentComboName"
                            value={agentComboName || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Role"
                            fullWidth={true}
                            name="Role"
                            value={Role || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Mobile No"
                            fullWidth={true}
                            name="MobileNumber"
                            value={mobileNo || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Divison"
                            fullWidth={true}
                            name="Division"
                            value={getDivision || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="District"
                            fullWidth={true}
                            name="District"
                            value={getDistrict || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Thana"
                            fullWidth={true}
                            name="Thana"
                            value={getThana || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <TextField
                            style={{ marginTop: "10px" }}
                            // select
                            size="small"
                            color="primary"
                            autoFocus={true}
                            type="text"
                            label="Union"
                            fullWidth={true}
                            name="Union"
                            value={getUnion || ""}
                            onChange={handleChange}
                            disabled
                        >

                        </TextField>
                        <div style={{ marginTop: "1.5rem" }}>

                            <TextField
                                required
                                select
                                size="small"
                                color="primary"
                                autoFocus={true}
                                type="text"
                                label="Dsr"
                                fullWidth={true}
                                // name="dsr"
                                name="getEmailOtp"
                                value={getEmailOtp || ""}
                                // value={level || ""}
                                // defaultValue={"Select Dsr" || dsr}
                                onChange={handleChange}
                            >

                                {setDsrList.success && [].concat(setDsrList.data.actionList)
                                    .map((x) => <MenuItem value={x.split("-")[0]}

                                    >{x}</MenuItem>)}

                            </TextField>
                        </div>
                    </DialogContent>

                    <DialogActions>
                        <CustomButton
                            style={{
                                // backgroundColor: "#fff",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={handleClose}
                        >
                            Cancel
                        </CustomButton>
                        <CustomButton
                            style={{
                                // backgroundColor: "#00b9f5",
                                color: "white"
                            }}
                            variant="contained"
                            onClick={getAddDsrReq}
                        >
                            Save
                        </CustomButton>
                    </DialogActions>
                </Dialog>


            </div>

            {deleteDealerDsrRes.data.status == "success" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDsrMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {deleteDealerDsrRes.data.status == "failed" && (
                <div>
                    <Dialog open={deleteNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {deleteDsrMasterArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getAddEditDsrListRes.data.status == "success" && (
                <div>
                    <Dialog open={addEditDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addEditDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getAddEditDsrListRes.data.status == "failed" && (
                <div>
                    <Dialog open={addEditDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addEditDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}


            {getAddDsrListRes.data.status == "success" && (
                <div>
                    <Dialog open={addDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={success} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

            {getAddDsrListRes.data.status == "failed" && (
                <div>
                    <Dialog open={addDsrNotification} onClose={handleNoticationClose}>
                        <DialogContent
                            className="text-center lightThemeBackground"
                        >
                            <img src={failed} alt="" width="100px" className="my-2" />
                        </DialogContent>
                        <DialogContent>
                            <h4
                                style={{ margin: "0", textAlign: "center", fontSize: "15px" }}
                            >
                                {addDsrStatusResArray.description}
                            </h4>
                        </DialogContent>
                        <DialogActions style={{ justifyContent: "center" }}>
                            <CustomButton
                                style={{
                                    padding: "8px",
                                }}
                                onClick={handleNoticationClose}
                            >
                                Ok
                            </CustomButton>
                        </DialogActions>
                    </Dialog>
                </div>
            )}

        </>
    )
}

export default DealerAgentMaster






